<template src="./Emails.html"></template>
<script>
import mixins from "../../../../Mixins.js";
export default {
  mixins: [mixins],
  data() {
    return {
      doctors: [],
      doctorsTemp: [],
      doctorsSearch: [],
      typedWord: "",
      windowWidth: 0,
      currentx: 0,
      numPages: 0,
      pagination: false,
      searchDoctors: "",
    }
  },
  mounted: function() {
    const vm = this;
    vm.init();
  },
  created() {
    const vm = this;
    window.addEventListener("resize", vm.handleResize);
    vm.handleResize();
  },
  destroyed() {
    const vm = this;
    window.removeEventListener("resize", vm.handleResize);
  },
  watch: {
    currentx: function () {
      const vm = this;
      vm.changePagination();
    },
  },
  methods: {
    init() {
      const vm = this;
      vm.getDoctors();
    },
    changePagination(){
      const vm = this;
      vm.getDoctors();
    },
    getDoctors() {
      const vm = this;
      const page = vm.currentx - 1;
      vm.$vs.loading();
      vm.axios
        .get(
          vm.$store.state.filooServer +
            "admin/doctors?page=" + page + "&search="+ vm.searchDoctors + "&size=10&sort=id,desc",
          {
            headers: { Authorization: vm.$session.get("bearer") }
          }
        )
        .then(function(response) {
          if (response.status === 200) {
            vm.doctors = response.data.content;
            vm.numPages = response.data.totalPages;
            vm.pagination = vm.numPages > 1;
          }
        }).finally(() => {
          vm.$vs.loading.close();
        });
    },
    changeSearchDoctors(){
      const vm = this;
      vm.currentx = 0;
      vm.$vs.loading();
      vm.getDoctors();
    },
    sendRenewPassword(docId){
        const vm = this;
        vm.axios
          .get(
            vm.$store.state.filooServer +
                "touchpoint/send-email-doctor-create-password",
            {
                headers: { Authorization: vm.$session.get("bearer") },
                params: { "doctorId": docId.id}
            }
          );
    },
    handleResize() {
      const vm = this;
      vm.windowWidth = window.innerWidth;
    },

  }
}
</script>
<style src="./Emails.css">
</style>
